export const helpRequestFieldLabels = {
  id: 'Identifiant',
  isFirst: "Il s'agit",
  status: 'Statut',
  dueDate: "Date d'échéance ou de rappel",
  beneficiaryId: 'Bénéficiaire',
  familyFileId: 'Dossier',
  examinationDate: 'Date de passage en commission',
  askedAmount: 'Montant demandé',
  allocatedAmount: 'Montant attribué',
  paymentMethod: 'Mode de paiement',
  paymentDate: 'Date du paiement',
  handlingDate: 'Date de fin de prise en charge',
  date: "Date d'ouverture du dossier",
  numeroPegase: 'Numéro Pégase',
  minister: 'Ministre',
  ministerId: 'Ministre',
  subjectId: "Objet de l'accompagnement",
  prescribingOrganizationId: 'Organisme prescripteur',
  prescribingOrganizationContactId: "Contact de l'organisme prescripteur",
  fullFile: 'Ce dossier est complet',
  instructorOrganizationId: 'Organisme instructeur',
  instructorOrganizationContactId: "Contact de l'organisme instructeur",
  dispatchDate: "Date d'envoi du dossier",
  decisionDate: 'Date de la décision',
  refusalReason: 'Motif du refus',
  refusalReasonOther: 'Autre motif du refus',
  synthesis: 'Compte rendu',
  privateSynthesis: 'Compte rendu privé',
  documents: 'Documents',
  externalStructure: 'Demande réalisée',
  updated: 'Dernière mise à jour',
  createdById: 'Agent',
  lastUpdatedById: 'Modifié par',
  financialSupport: 'Aide financière',
  isRefundable: 'Cette aide est-elle remboursable ?',
  endOfSocialSupport: "Fin d'accompagnement",
  supportProgramId: "Dispositif ou axe d'intervention"
}
